import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20gradient%20wave%20background%20with%20warm%20coral%20and%20soft%20amber%20tones%2C%20flowing%20organic%20curves%2C%20minimalist%20design%2C%20ethereal%20atmosphere%2C%20subtle%20geometric%20patterns%2C%20clean%20digital%20art%20style%2C%20warm%20inviting%20color%20palette%2C%20professional%20quality%2C%208K%20resolution&width=1600&height=900&seq=hero-bg-main-01&orientation=landscape"
          alt="91免费 - 免费看片软件推荐平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            91免费看片app
            <span className="block text-primary-300">免费看片软件下载平台</span>
          </h1>
          <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            下载91免费看片app和91免费软件，实现移动端或电脑端免费看片。提供最新版本免费视频软件下载，支持安卓和苹果，流畅稳定，看片app免费安装。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/latest-recommend"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              查看最新推荐
            </Link>
            <Link
              to="/category/tutorial"
              className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap"
            >
              使用教程
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}